import React, { useState } from 'react';
import { 
  Card, 
  Form, 
  Input, 
  Button, 
  Checkbox, 
  message,
  Tabs,
  Divider,
  Row,
  Col,
  Typography,
  Space
} from 'antd';
import { 
  UserOutlined, 
  LockOutlined, 
  MailOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  HeartOutlined,
  StarOutlined,
  CoffeeOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Title, Text, Paragraph } = Typography;
const { TabPane } = Tabs;
const { Item } = Form;

const Home = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('login');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginForm] = Form.useForm();
  const [registerForm] = Form.useForm();

  // 背景图片数组 - 随机选择
  const backgroundImages = [
    'https://images.unsplash.com/photo-1542435503-956c469947f6?q=80&w=2574&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1550684376-efcbd6e3f031?q=80&w=2670&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1511895426328-dc8714191300?q=80&w=2670&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=2670&auto=format&fit=crop'
  ];

  // 随机选择背景图片
  const randomBackground = backgroundImages[Math.floor(Math.random() * backgroundImages.length)];

  // 可爱图标
  const cuteIcons = ['🌸', '✨', '🐱', '🐶', '🍓', '🍰', '🎀', '📝', '💌', '📚'];

  // 生成随机图标
  const getRandomIcon = () => {
    return cuteIcons[Math.floor(Math.random() * cuteIcons.length)];
  };

  // 登录处理
  const handleLogin = async (values) => {
  setLoading(true);
  try {
    console.log('登录数据:', values);
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    if (values.username && values.password) {
      // 创建用户唯一ID
      const userId = `user_${Date.now()}`;
      
      // 保存用户信息到 localStorage
      const userData = {
        userId,
        username: values.username,
        loggedIn: true,
        isGuest: false,
        loginTime: new Date().toISOString(),
        avatar: `https://i.pravatar.cc/150?u=${userId}`,
        // 可爱的默认信息
        nickname: values.username || '日记小可爱',
        tagline: '记录每一天的小确幸 ✨',
        motto: '今天也要加油鸭！',
        startDate: new Date().toLocaleDateString('zh-CN'),
        location: '幸福小窝',
        email: `${values.username}@diary.com`,
        signature: 'ฅ^•ﻌ•^ฅ'
      };
      
      localStorage.setItem('currentUser', JSON.stringify(userData));
      message.success('登录成功！欢迎来到日记星球 ✨');
      navigate('/about'); // 登录后跳转到 About 页面
    } else {
      message.error('请输入完整的登录信息');
    }
  } catch (error) {
    message.error('登录失败，请重试');
  } finally {
    setLoading(false);
  }
};

// 修改游客登录函数
const handleGuestLogin = () => {
  const userId = `guest_${Date.now()}`;
  const userData = {
    userId,
    username: '小游客',
    loggedIn: true,
    isGuest: true,
    loginTime: new Date().toISOString(),
    avatar: 'https://i.pravatar.cc/150?img=32',
    nickname: '好奇的游客',
    tagline: '我只是来参观一下的~',
    motto: '悄悄来，悄悄走',
    startDate: new Date().toLocaleDateString('zh-CN'),
    location: '游客中心',
    email: 'visitor@diary.com',
    signature: '👀'
  };
  
  localStorage.setItem('currentUser', JSON.stringify(userData));
  message.info('欢迎游客！可以体验基础功能哦~');
  navigate('/about');
};

// 在注册处理函数中也添加用户创建
const handleRegister = async (values) => {
  setLoading(true);
  try {
    console.log('注册数据:', values);
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    if (values.password !== values.confirmPassword) {
      message.error('两次输入的密码不一致');
      return;
    }
    
    // 注册成功后自动登录
    const userId = `user_${Date.now()}`;
    const userData = {
      userId,
      username: values.username,
      loggedIn: true,
      isGuest: false,
      loginTime: new Date().toISOString(),
      avatar: `https://i.pravatar.cc/150?u=${userId}`,
      nickname: values.username || '新朋友',
      tagline: '刚刚加入日记星球的新成员！',
      motto: '开始记录我的生活啦~',
      startDate: new Date().toLocaleDateString('zh-CN'),
      location: '新手村',
      email: values.email,
      signature: '🎉'
    };
    
    localStorage.setItem('currentUser', JSON.stringify(userData));
    message.success('注册成功！已自动登录 ✨');
    setActiveTab('login');
    registerForm.resetFields();
    navigate('/about');
  } catch (error) {
    message.error('注册失败，请重试');
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="cute-login-container">
      {/* 模糊背景层 */}
      <div 
        className="background-layer"
        style={{ backgroundImage: `url(${randomBackground})` }}
      />
      <div className="background-overlay" />
      
      {/* 漂浮的可爱元素 */}
      <div className="floating-elements">
        {[...Array(8)].map((_, index) => (
          <div 
            key={index}
            className="floating-element"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              fontSize: `${Math.random() * 20 + 20}px`
            }}
          >
            {getRandomIcon()}
          </div>
        ))}
      </div>

      <div className="login-content">
        <Card className="cute-login-card">
          {/* 头部装饰 */}
          <div className="card-header-decor">
            <div className="decor-left">
              <span className="decor-icon">🌸</span>
              <span className="decor-icon">✨</span>
            </div>
            <div className="decor-right">
              <span className="decor-icon">✨</span>
              <span className="decor-icon">🌸</span>
            </div>
          </div>

          {/* 欢迎标题 */}
          <div className="welcome-section">
            <div className="welcome-icon">📝</div>
            <Title level={2} className="welcome-title">
              欢迎来到<span className="highlight">日记星球</span>
            </Title>
            <Paragraph className="welcome-subtitle">
              记录每一天的小确幸和大梦想
            </Paragraph>
          </div>

          <Tabs 
            activeKey={activeTab} 
            onChange={setActiveTab}
            className="cute-tabs"
            centered
          >
            {/* 登录标签页 */}
            <TabPane tab={<span className="tab-label">✨ 登录</span>} key="login">
              <Form
                form={loginForm}
                onFinish={handleLogin}
                layout="vertical"
                size="large"
              >
                <Item
                  name="username"
                  rules={[
                    { required: true, message: '请输入用户名' },
                    { min: 2, message: '用户名至少2个字符' }
                  ]}
                >
                  <Input
                    placeholder="请输入用户名"
                    prefix={<UserOutlined className="input-icon" />}
                    className="cute-input"
                    suffix={<span className="input-suffix">👤</span>}
                  />
                </Item>

                <Item
                  name="password"
                  rules={[
                    { required: true, message: '请输入密码' },
                    { min: 6, message: '密码至少6个字符' }
                  ]}
                  style={{ marginBottom: 20 }}
                >
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="请输入密码"
                    prefix={<LockOutlined className="input-icon" />}
                    className="cute-input"
                    suffix={
                      <Button
                        type="text"
                        icon={showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                        onClick={() => setShowPassword(!showPassword)}
                        className="password-toggle"
                      />
                    }
                  />
                </Item>

                <Row justify="space-between" align="middle">
                  <Col>
                    <Item name="remember" valuePropName="checked" noStyle>
                      <Checkbox className="cute-checkbox">
                        <Text>记住我</Text>
                      </Checkbox>
                    </Item>
                  </Col>
                  <Col>
                    <Button type="link" className="forgot-link">
                      忘记密码？
                    </Button>
                  </Col>
                </Row>

                <Item style={{ marginTop: 24 }}>
                  <Button 
                    type="primary" 
                    htmlType="submit" 
                    block
                    size="large"
                    loading={loading}
                    className="login-button"
                  >
                    <Space>
                      <span>登录日记星球</span>
                      <span>✨</span>
                    </Space>
                  </Button>
                </Item>

                <div className="quick-login-section">
                  <Divider className="cute-divider">
                    <Text type="secondary">快速登录</Text>
                  </Divider>
                  
                  <Button 
                    block 
                    size="large"
                    onClick={handleGuestLogin}
                    className="guest-button"
                  >
                    <Space>
                      <CoffeeOutlined />
                      <span>游客体验</span>
                    </Space>
                  </Button>
                </div>
              </Form>
            </TabPane>

            {/* 注册标签页 */}
            <TabPane tab={<span className="tab-label">🌟 注册</span>} key="register">
              <Form
                form={registerForm}
                onFinish={handleRegister}
                layout="vertical"
                size="large"
              >
                <Item
                  name="username"
                  rules={[
                    { required: true, message: '请输入用户名' },
                    { min: 2, message: '用户名至少2个字符' },
                    { max: 12, message: '用户名不能超过12个字符' }
                  ]}
                >
                  <Input
                    placeholder="取个可爱的名字吧"
                    prefix={<UserOutlined className="input-icon" />}
                    className="cute-input"
                    suffix={<span className="input-suffix">🐰</span>}
                  />
                </Item>

                <Item
                  name="email"
                  rules={[
                    { required: true, message: '请输入邮箱' },
                    { type: 'email', message: '请输入有效的邮箱地址' }
                  ]}
                >
                  <Input
                    placeholder="请输入邮箱"
                    prefix={<MailOutlined className="input-icon" />}
                    className="cute-input"
                    suffix={<span className="input-suffix">📮</span>}
                  />
                </Item>

                <Item
                  name="password"
                  rules={[
                    { required: true, message: '请输入密码' },
                    { min: 6, message: '密码至少6个字符' },
                    { pattern: /^(?=.*[A-Za-z])(?=.*\d).{6,}$/, message: '密码需包含字母和数字' }
                  ]}
                >
                  <Input.Password
                    placeholder="设置一个安全的密码"
                    prefix={<LockOutlined className="input-icon" />}
                    className="cute-input"
                    visibilityToggle={false}
                  />
                </Item>

                <Item
                  name="confirmPassword"
                  dependencies={['password']}
                  rules={[
                    { required: true, message: '请确认密码' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('两次输入的密码不一致'));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    placeholder="再次输入密码"
                    prefix={<LockOutlined className="input-icon" />}
                    className="cute-input"
                    visibilityToggle={false}
                  />
                </Item>

                <Item
                  name="agreement"
                  valuePropName="checked"
                  rules={[
                    {
                      validator: (_, value) =>
                        value ? Promise.resolve() : Promise.reject(new Error('请同意用户协议')),
                    },
                  ]}
                  style={{ marginBottom: 24 }}
                >
                  <Checkbox className="cute-checkbox">
                    我已阅读并同意{' '}
                    <Button type="link" className="agreement-link">
                      《用户协议》
                    </Button>
                    和{' '}
                    <Button type="link" className="agreement-link">
                      《隐私政策》
                    </Button>
                  </Checkbox>
                </Item>

                <Item>
                  <Button 
                    type="primary" 
                    htmlType="submit" 
                    block
                    size="large"
                    loading={loading}
                    className="register-button"
                  >
                    <Space>
                      <span>加入日记星球</span>
                      <StarOutlined />
                    </Space>
                  </Button>
                </Item>

                <div className="register-features">
                  <Divider className="cute-divider">
                    <Text type="secondary">加入即可获得</Text>
                  </Divider>
                  
                  <Row gutter={[16, 16]} className="feature-list">
                    <Col span={12}>
                      <div className="feature-item">
                        <div className="feature-icon">📖</div>
                        <div className="feature-text">无限日记空间</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="feature-item">
                        <div className="feature-icon">🔒</div>
                        <div className="feature-text">隐私保护</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="feature-item">
                        <div className="feature-icon">🌈</div>
                        <div className="feature-text">多彩主题</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="feature-item">
                        <div className="feature-icon">💾</div>
                        <div className="feature-text">永久保存</div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Form>
            </TabPane>
          </Tabs>

          {/* 底部装饰 */}
          <div className="card-footer-decor">
            <HeartOutlined className="footer-heart" />
            <Text type="secondary" className="footer-text">
              每一天都值得被记录 ✨
            </Text>
            <HeartOutlined className="footer-heart" />
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Home;